import { loading } from './modules/loading';
loading();

import { aboutSlide } from './modules/aboutSlide';
aboutSlide();

document.addEventListener('DOMContentLoaded', function () {

	const target = document.querySelector('.p-home_header');
	const header = document.querySelector('.j-header');

	const observer = new IntersectionObserver(
		(entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
			// p-home_headerが画面外（通過後）
			header.classList.add('is-view');
			} else {
			// p-home_headerが画面内にある
			header.classList.remove('is-view');
			}
		});
		},
		{
		root: null, // ビューポート
		threshold: 0, // 交差してるかどうかをチェック
		}
	);

	if (target) {
		observer.observe(target);
	}
});
